import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { finalize, takeWhile } from 'rxjs/operators';
import { Step } from '@shared/models/step';
import ContentSteps from '@routes/tickets/ticket-edit/contents/contents-steps';
import { PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
import { ServiceCenter } from '@shared/models/ticket-info';
import { TicketCreate } from '@shared/models/ticket-create';
import Utils from '@shared/utils/utils';
import { Ticket } from '@routes/ticket-manager/ticket';
import { TicketService } from '@routes/ticket-manager/ticket.service';
import { Subject } from 'rxjs';
import { AuthService } from '@core/auth/auth.service';
import { ApiService } from '@shared/apis';
import { EventService } from '@shared/services/event.service';
import { TicketManager } from '@routes/ticket-manager';
import { SpinnerService } from '@shared/services/spinner.service';
import * as _ from 'lodash-es';
import { Basic } from '@shared/models/basic';
import { Symptom } from '@shared/models/symptom';
import { Constants } from '@shared/constants/constants';
import { Product } from '@shared/models/product';
import Swal from 'sweetalert2';
import Roles from '@shared/constants/roles';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  ConversationEditComponent
} from '@routes/tickets/ticket-edit/details/conversation/conversation-edit/conversation-edit.component';
import DateUtils from '@shared/utils/date-utils';
import Configs from '@shared/constants/configs';
import { Company } from '@shared/enums/company';
import Role from '@shared/constants/role';
import { RejectServiceRequest } from '@routes/dialogs/reject-service-request/reject-service-request.component';
import { MenuService } from '@layouts/menu/menu.service';
import { Router } from '@angular/router';
import { AttachmentViewComponent } from '@routes/dialogs/attachment-view/attachment-view.component';
import { TicketApi } from '@shared/apis/ticket.api';
import { FileService } from '@shared/services/file.service';

let nextId = 0;

@Component({
  selector: 'app-ticket-create',
  templateUrl: './ticket-edit.component.html',
  styleUrls: ['./ticket-edit.component.scss']
})
export class TicketEditComponent implements OnInit, OnDestroy {
  @Output() detailUpdateEvent = new EventEmitter();
  @Input() ticketNo
  bsModalRef: BsModalRef;
  readonly constants = Constants;
  readonly utils = Utils;
  readonly configs = Configs;

  steps: Step[] = [];
  ticketEvents: any[] = [];

  userType: any;
  logParty = 'log';
  logPartyOptions: any[] = [];

  basic: Basic;
  symptoms: Symptom[];
  serviceCenter: ServiceCenter;
  scheduleDate: any;
  inquiry: any;


  product: Product;
  serverFile: any;

  ticket: Ticket;
  ticketService: TicketService;

  message: any;

  isOpen = false;
  isDealer = false;

  destroy: Subject<any> = new Subject<any>();
  subscription: any = {};

  daysAfterCreation: number;

  attachmentsList: any = [];

  companies = Company;
  company;
  isAgent;
  isAdmin;
  isAdminViewerRole;
  isDetail = false;
  isTicketEditable;
  isDraftTicket = false;
  doNotAllowComment: boolean;

  inquiryPlaceHolder = 'Please enter any additional details about the nature of your service request that may be helpful to the Technician performing your repair.';

  logParams: any = {};
  @ViewChild('perfectScroll') perfectScroll: PerfectScrollbarComponent;
  private alive = true;

  constructor(private authService: AuthService,
              private apiService: ApiService,
              public eventService: EventService,
              public ticketManager: TicketManager,
              private modalService: BsModalService,
              private menuService: MenuService,
              private spinnerService: SpinnerService,
              private ticketApiService: TicketApi,
              private router: Router,
              protected fileService: FileService,) {
    nextId++;
    this.isDealer = this.authService.hasType(Roles.dealer);
    this.doNotAllowComment = this.authService.getUser().doNotAllowComment || false;
    this.company = this.authService.getCurrentCompany();
    this.isAgent = this.authService.hasRole(Role.secaAgent, this.company);
    this.isAdmin = this.authService.hasRole(Role.secaAdmin, this.company);
    this.isAdminViewerRole = this.authService.checkHasAdminViewerRole();
  }

  ngOnInit(): void {
    const token = this.authService.getToken();
    const { userType } = token;

    this.logParty = userType === 'DEALER' ? 'log' : 'email';
    this.logPartyOptions = this.constants.logParty.filter(f => f.role.includes(userType));
    console.log('this.logPartyOptions >>>>>>>>>>>>>>>>>>>>', this.logPartyOptions);

    this.steps = ContentSteps.STEPS;

    this.subscription.ticketEdit = this.ticketManager.activeTicket$
      .pipe(takeWhile(() => this.alive))
      .subscribe(ticket => {
        if (!ticket) {
          return;
        }

        const { ticketInfo, ticketService } = ticket;
        const { auth, symptoms } = ticketInfo;
        if (auth) {
          const { createdAt } = auth;
          this.daysAfterCreation = DateUtils.dateDiff(createdAt);
        }

        if (this.subscription.ticketEdit) {
          this.subscription.ticketEdit.unsubscribe();
          return;
        }

        this.ticket = ticket;
        if (ticketInfo.ticketNo && ticketInfo.ticketNo.length === 10) {
          const ticketNo = ticketInfo.ticketNo;
          this.isDraftTicket = ticketNo?.substring(0, 1) === 'D';
        }
        this.ticketService = ticketService;
        // this.logPartyOptions = !ticketInfo.escalatable ? this.logPartyOptions.filter(logParty => logParty.code !== 'escalation') : this.logPartyOptions;

        this.isTicketEditable = (ticketInfo.processType === Constants.processType.SR && [Constants.gcicStatus.SR_PENDING.code].includes(ticketInfo.status) ||
          ticketInfo.processType === Constants.processType.SO && Constants.gcic4kEditableStatus.includes(ticketInfo.status));
        this.ticketServiceSubscribe(ticketInfo);
      });

    this.ticket.ticketChanged$
      .pipe(takeWhile(() => this.alive))
      .subscribe(ticketInfo => {
        if (!ticketInfo) {
          return;
        }
        this.ticketNo = ticketInfo.ticketNo;
        this.ticketServiceSubscribe(ticketInfo);
      });

    if (this.ticket.ticketInfo.status !== 'new') {
      this.getAttachmentsList().then();
    }
    this.tabClose();
  }

  createThumbnailList(attachment) {
    if (!this.attachmentsList) {
      return null;
    }

    if (this.isImageFile(attachment)) {
      return this.ticketApiService.attachmentUrl(this.ticket.ticketInfo, attachment, 'inline');
    } else {
      return null;
    }

  }

  onClickAttachment(attachment) {
    if (!attachment) {
      return;
    }

    if (this.isImageFile(attachment)) {
      this.showAttachmentViewer(attachment);
    } else {
      const file = this.ticketApiService.attachmentUrl(this.ticket.ticketInfo, attachment, 'attachment');
      this.fileService.downloadFile(file, attachment.filename);
    }
  }

  ticketServiceSubscribe(ticketInfo) {
    const { status } = ticketInfo;
    if (status !== 'new') {
      this.ticketService.setDetailData(ticketInfo);
      this.isDetail = true;
    }

    this.ticketService.data$
      .pipe(takeWhile(() => this.alive))
      .subscribe((ticket: TicketCreate) => {
        if (Utils.isEmpty(ticket)) {
          return;
        }
        const { basic, inquiry, scheduleDate, serviceCenter, product, serverFile } = ticket;
        setTimeout(() => {
          this.basic = basic;
          this.inquiry = inquiry;
          this.scheduleDate = scheduleDate;
          this.serviceCenter = serviceCenter;
          this.product = product;
          this.serverFile = serverFile;
        });
      });

    this.ticketService?.isScroll$
      .pipe(takeWhile(() => this.alive))
      .subscribe(x => {
        if (x) {
          this.scrollToBottom();
        }
      });
  }

  ngOnDestroy() {
    this.alive = false;
  }

  isEditable(step) {
    // console.log('ticket-edit.component.ts >>>>>>>>>>>>>>>>>>>>', step);
    return this.ticketService.isEditable(step);
  }

  createTicket() {
    const previousTicketNo = this.ticket.ticketInfo.ticketNo;
    const { customerType, serviceType } = this.basic;
    const { warrantyTerm, purchaseDate, demoUnit, fmr } = this.product;
    const { filename } = this.serverFile || {};

    // required field check start
    let fields = [];
    if (warrantyTerm === 'OW'
      && customerType === Constants.customerType.CUSTOMER
      && (!purchaseDate || !filename)
      && [this.companies.Sea].includes(this.company)) {
      fields = [{
        name: 'Purchase Date',
        field: purchaseDate,
      }, {
        name: 'Receipts',
        field: filename,
      }];
    }

    if (demoUnit && !fmr) {
      fields.push({
        name: 'FmrId',
        field: fmr,
      });
    }
    if (fields.length) {
      const filedNames = fields.filter(f => !f.field).map(m => m.name).join(',');
      Swal.fire({
        icon: 'error',
        title: `Please required fields check.(${ filedNames })`,
        showConfirmButton: true,
      });
      return;
    }
    // required End

    this.spinnerService.start();
    this.ticketService.saveTicket(this.inquiry)
      .then(res => {
        const ticket = _.cloneDeep(this.ticket);
        ticket.status = 'changed';
        ticket.isEdit = false;

        this.apiService.ticket.getTicket(res.ticketNo)
          .pipe(finalize(() => this.spinnerService.stop()))
          .subscribe(ticketInfo => {
            ticketInfo.previousTicketNo = previousTicketNo;

            ticket.ticketInfo = ticketInfo;
            Swal.fire({
              title: 'Ticket Create',
              text: 'Ticket created successfully.',
              icon: 'success',
              allowOutsideClick: false,
            }).then((result) => {
            });
            this.ticketManager.changeTicket(ticket);
          }, err => Utils.showError(err));
      })
      .catch(err => {
        this.spinnerService.stop();
        Utils.showError(err);
      });
  }

  updateTicket() {
    this.spinnerService.start();
    this.ticketService.updateTicket()
      .then(res => {
        this.setUpdateTicketData(res);
        this.spinnerService.stop();
        Swal.fire({
          title: 'Ticket Update',
          text: 'Ticket updated successfully.',
          icon: 'success',
          allowOutsideClick: false,
        }).then(() => {

        });
      })
      .catch(err => {
        this.spinnerService.stop();
        Utils.showError(err);
      });
  }

  cancelDraftTicket() {
    this.spinnerService.start();
    this.ticketService.cancelDraftTicket()
      .then(res => {
        this.setUpdateTicketData(res);
        this.spinnerService.stop();
        Swal.fire({
          title: 'Ticket Deleted',
          text: 'Ticket deleted successfully.',
          icon: 'success',
          allowOutsideClick: false,
        }).then(() => {
          this.eventService.closeTab$.next({ ticketNo: this.ticketNo });
        });
      })
      .catch(err => {
        this.spinnerService.stop();
        Utils.showError(err);
      });
  }

  approve5KTicket() {
    Swal.fire({
      title: 'Check Service Centre',
      text: 'Have you checked service centre?',
      icon: 'info',
      showCancelButton: true,
      showConfirmButton: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinnerService.start();
        const status = Constants.gcicStatus.SR_COMPLETE.code;
        const reason = Constants.gcicStatus.SR_COMPLETE.reason;
        this.ticketService.approve5kTicket(status, reason)
          .then(res => {
            this.basic.status = status;
            this.basic.reason = reason;
            if (res.new4kTicketNo) {
              this.spinnerService.start();
              this.apiService.ticket.getTicket(res.new4kTicketNo)
                .pipe(finalize(() => this.spinnerService.stop()))
                .subscribe(res => {
                  this.ticketManager.addTicket(res, false);
                });
            }
            this.setUpdateTicketData(res);
            this.spinnerService.stop();
            Swal.fire({
              title: 'Ticket Approved',
              text: 'Ticket approved successfully.',
              icon: 'success',
              allowOutsideClick: false,
            }).then((result) => {
            });
            this.isTicketEditable = false;
          })
          .catch(err => {
            this.spinnerService.stop();
            Utils.showError(err);
          });
      }
    });

  }

  reject5KTicket(result) {
    this.spinnerService.start();
    this.ticketService.reject5kTicket(result)
      .then(res => {
        this.setUpdateTicketData(res);
        this.spinnerService.stop();
        Swal.fire({
          title: 'Ticket Rejected',
          text: 'Ticket rejected.',
          icon: 'success',
          allowOutsideClick: false,
        }).then((result) => {
        });
        this.isTicketEditable = false;
      })
      .catch(err => {
        this.spinnerService.stop();
        Utils.showError(err);
      });
  }

  syncTicket(ticketNo) {
    this.spinnerService.start();
    this.apiService.ticket.syncTicket(ticketNo)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.ticket.ticketChanged$.next(res);
        this.ticket.conversation$.next(res.logs);

        this.setUpdateTicketData(res);
        if ([this.companies.Seca].includes(this.company)) {
          Swal.fire({
            title: 'Ticket Sync',
            text: 'Ticket Synced Successfully.',
            icon: 'success',
            allowOutsideClick: false,
          }).then((result) => {
          });
        }
      }, err => {
        Utils.showError(err);
      });
  }

  setUpdateTicketData(res) {
    const ticket = this.ticket;
    ticket.isEdit = false;
    ticket.ticketInfo = res;

    this.ticketManager.updateTicket = ticket;
    this.ticketService.resetSerial = false;
  }

  scrollToBottom() {
    setTimeout(() => {
      this.perfectScroll.directiveRef.scrollToBottom(0, 300);
    });
  }

  cancelTicket() {
    const basic: Basic = {
      isCancel: true
    };
    this.ticketService.patch({ basic }, 'cancelTicket');
  }

  onOpenChange($event: boolean) {
    setTimeout(() => {
      this.isOpen = $event;
    });
  }

  submit() {
    if (!this.message) {
      return;
    }

    const selectedLogParty = this.logPartyOptions.find(f => f.code === this.logParty)

    const params: any = {
      channel: selectedLogParty.channel,
      to: selectedLogParty.to,
      log: this.message,
      code: selectedLogParty.code,
    };

    // TODO
    /*switch (action) {
      case 'email':
      case 'escalation':
        params.channel = TicketLogChannel.Email;
        params.to = this.logParty;
        break;
      case 'comment':
      case 'memo':
        break;
    }*/

    this.spinnerService.start();
    this.apiService.ticket.log(this.ticketNo, params)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.message = null;
        const { logs } = res;
        this.ticket.conversation$.next(logs);
      }, err => Utils.showError(err));
  }

  deleteComponent() {
    this.destroy.next(null);
  }

  escalateTicket(ticketInfo) {
    const initialState = {
      ticketNo: ticketInfo.ticketNo,
      title: 'Add Comment',
      dealerInfo: ticketInfo,
      buttonLabel: 'Submit',
      logPartyOptions: this.logPartyOptions,
      logParty: 'escalation',
      initialMessage: 'Please explain the reason for comment, providing as much detail as possible'
    };
    console.log('initialState >>>>>>>>>>>>>>>>>>>>', initialState);

    this.bsModalRef = this.modalService.show(ConversationEditComponent, { initialState, class: 'modal-lg' });
    this.bsModalRef.content.onClose.subscribe(result => {
      if (result) {
        this.ticket.conversation$.next(result);
      }
    });
  }

  raRequest(ticketInfo) {
    if (this.daysAfterCreation < 14) {
      const phoneNumber = [Constants.purchasePlace.BUILDER].includes(ticketInfo.dealerStore.purchasePlaceCode) ?
        '1-844-726-4253' : '1-866-797-8727';
      Swal.fire({
        title: `To continue with a Return Authorization request, please call us at ${ phoneNumber }`,
        confirmButtonText: 'OK',
        icon: 'warning',
      }).then((result) => {
      });
    } else {
      const initialState = {
        ticketNo: ticketInfo.ticketNo,
        title: 'Request Return Authorization',
        dealerInfo: ticketInfo,
        buttonLabel: 'Submit',
        logPartyOptions: this.logPartyOptions,
        logParty: 'enr',
        initialMessage: 'Please explain the reason for your Return Authorization request, providing as much detail as possible'
      };

      this.bsModalRef = this.modalService.show(ConversationEditComponent, { initialState, class: 'modal-lg' });
      this.bsModalRef.content.onClose.subscribe(result => {
        if (result) {
          this.ticket.conversation$.next(result);
        }
      });
    }
  }

  setRejectReason() {

    const title = 'Reject Service Request';

    let initialState: any = {
      title,
    };


    this.bsModalRef = this.modalService.show(RejectServiceRequest, { initialState });
    this.bsModalRef.content.onClose.subscribe(result => {
      if (result) {
        if (result.confirm) {
          this.reject5KTicket(result);
        }
      }
    });
  }

  goToPayment(event) {
    const menu = this.menuService.getMenu();
    const payments = menu.find(f => f.componentId === 'payments');
    this.menuService.selectedMenu$.next(payments);
    return this.router.navigate(['/payments']);
  }

  private async getAttachmentsList() {
    const params = {
      company: this.company,
      ticketNo: this.ticketNo
    }

    const ticketAttachment = this.ticket.ticketInfo.attachments;

    const getAttachmentsListPromise = new Promise((resolve, reject) => {
      this.apiService.ticket.getAttachmentsList(params).subscribe(res => {
        resolve(res);
      });
    })

    await Promise.all([getAttachmentsListPromise]).then((resolve: any) => {
      const normalizedArray2 = resolve[0].map(item => ({
        ...item,
        filename: item.FileName,
        size: item.FileSize,
        createDate: item.CreateDate,
        createTime: item.CreateTime,
        createBy: item.CreateBy
      }));

      let uniqueArray;

      if ([Constants.serviceCode.COSMETIC_REPAIR, Constants.serviceCode.INSTALL_CHECKING].includes(this.ticket.ticketInfo.serviceType)) {
        uniqueArray = normalizedArray2.filter((item) => this.isUnique(item, ticketAttachment));
      } else {
        const bosFile = ticketAttachment?.filter(item => {
          return item.bos
        })
        uniqueArray = normalizedArray2.filter((item) => this.isUnique(item, bosFile));
      }

      uniqueArray.map(uniqueItem => {
        let map = {
          filename: uniqueItem.FileName || uniqueItem.filename,
          objectKey: uniqueItem.ObjectKey || uniqueItem.objectKey,
        };
        this.attachmentsList.push(map);
      });
    })
  }

  private isUnique(item, ticketAttachment) {
    const normalizedFilename = item.FileName.toLowerCase();
    return !ticketAttachment?.some((attachment) => {
      let attachmentFilename = attachment.filename.toLowerCase();
      if (attachment.bos) {
        attachmentFilename = `pop_${ attachmentFilename }`;
      }
      return normalizedFilename === attachmentFilename;
    });
  }

  private showAttachmentViewer(attachment) {
    this.spinnerService.start();

    const image = new Image();
    const src = this.ticketApiService.attachmentUrl(this.ticket.ticketInfo, attachment, 'inline');
    const ticketInfo = this.ticket.ticketInfo
    const initialState = {
      attachmentImage: src,
      params: {
        ticketInfo,
        attachment,
      },
    };

    this.modalService.show(AttachmentViewComponent, {
      initialState,
      class: 'modal-lg',
    });

    image.onerror = () => {
      this.spinnerService.stop();
    };
  }

  private isImageFile(attachment): boolean {
    const name: string = attachment.filename;
    if (!name) {
      return false;
    }

    return (/\.(gif|jpg|jpeg|tiff|png)$/i).test(name.toLowerCase());
  }

  private tabClose() {
    this.eventService.closeTab$
      .pipe(takeWhile(() => this.alive))
      .subscribe(closeTicketNo => {

        if (closeTicketNo.constructor !== {}.constructor && closeTicketNo) {
          const el = document.getElementById(`close_${ closeTicketNo }`);
          if (el) {
            el.click();
          }
        }
      });
  }

}
